<template>
  <v-row class="mb-2" dense justify="center">
    <template v-for="(item, i) in stats">
      <v-col v-bind="item.grid" :key="i">
        <v-card flat class="pa-0">
          <v-list class="pa-0">
            <v-list-item>
              <v-list-item-icon>
                <v-icon size="60" :color="item.color">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content class="ml-n5">
                <div :class="`font-weight-bold ${item.color}--text`">
                  {{ item.label }}
                </div>
                <h2 :class="`${item.color}--text`">{{ $getDeepObj(value, item.key) || 0 }}</h2>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </template>
  </v-row>
</template>

<script>
export default {
  name: 'StatistikBase',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    stats: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style scoped></style>
